import { render } from "./SwdOpportunityItemActions.vue?vue&type=template&id=f6dce896"
import script from "./SwdOpportunityItemActions.vue?vue&type=script&lang=js"
export * from "./SwdOpportunityItemActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__